/**
 * MasalSensin Carousel Arrows + Auto-Rotate (5s)
 */
(function(){
  if (typeof window === 'undefined') return;
  var SELECTORS = ['.ms-fc__track', '.ms-deg__track'];
  var AUTO_INTERVAL_MS = 5000;
  var INTERACTION_PAUSE_MS = 10000;
  var DESKTOP_MIN = 1024;

  function chevSvg(dir) {
    var d = dir === 'left' ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6';
    return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>';
  }

  function attachArrows(track) {
    if (!track || track.dataset.msArrowsAttached === '1') return;
    var parent = track.parentElement;
    if (!parent) return;
    var ps = getComputedStyle(parent);
    if (ps.position === 'static') parent.style.position = 'relative';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'ms-carousel-arrow ms-carousel-arrow--prev';
    prev.setAttribute('aria-label', 'Önceki');
    prev.innerHTML = chevSvg('left');
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'ms-carousel-arrow ms-carousel-arrow--next';
    next.setAttribute('aria-label', 'Sonraki');
    next.innerHTML = chevSvg('right');
    parent.appendChild(prev);
    parent.appendChild(next);

    function getStep() { return Math.max(320, Math.round(track.clientWidth * 0.8)); }
    function atStart() { return track.scrollLeft <= 5; }
    function atEnd() { return track.scrollLeft >= track.scrollWidth - track.clientWidth - 5; }
    function updateState() {
      prev.classList.toggle('ms-carousel-arrow--disabled', atStart());
      next.classList.toggle('ms-carousel-arrow--disabled', atEnd());
      if (track.scrollWidth <= track.clientWidth + 5) {
        prev.style.display = 'none';
        next.style.display = 'none';
      } else {
        prev.style.display = '';
        next.style.display = '';
      }
    }

    var autoTimer = null;
    var pausedUntil = 0;
    var isHovered = false;
    function tick() {
      if (window.innerWidth < DESKTOP_MIN) return;
      if (isHovered) return;
      if (Date.now() < pausedUntil) return;
      if (track.scrollWidth <= track.clientWidth + 5) return;
      if (atEnd()) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      }
    }
    function startAuto() {
      if (autoTimer) return;
      autoTimer = setInterval(tick, AUTO_INTERVAL_MS);
    }
    function pauseFor(ms) { pausedUntil = Date.now() + ms; }

    prev.addEventListener('click', function(){
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      pauseFor(INTERACTION_PAUSE_MS);
    });
    next.addEventListener('click', function(){
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
      pauseFor(INTERACTION_PAUSE_MS);
    });
    track.addEventListener('scroll', updateState, { passive: true });
    track.addEventListener('touchstart', function(){ pauseFor(INTERACTION_PAUSE_MS); }, { passive: true });
    track.addEventListener('wheel', function(){ pauseFor(INTERACTION_PAUSE_MS); }, { passive: true });
    parent.addEventListener('mouseenter', function(){ isHovered = true; });
    parent.addEventListener('mouseleave', function(){ isHovered = false; });
    window.addEventListener('resize', updateState, { passive: true });

    updateState();
    startAuto();
    track.dataset.msArrowsAttached = '1';
  }

  function init() {
    SELECTORS.forEach(function(sel){
      document.querySelectorAll(sel).forEach(attachArrows);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();